module.exports = __webpack_public_path__ + "static/media/footui_6.baf76710.gif";